export default {
    noProducts: {
        title: 'No products',
        text: 'There are no products in this category.'
    },
    loadMore: 'Load more',
    helpLink: 'Help'
}